// ** React Imports
import { useEffect, useState, createContext } from 'react';

// ** Create Context
const ThemeColors = createContext();

const ThemeContext = ({ children }) => {
	// ** State
	const [colors, setColors] = useState({});

	//** ComponentDidMount
	useEffect(() => {
		if (window !== 'undefined') {
			//** Get variable value
			const getHex = (color) =>
				window.getComputedStyle(document.body).getPropertyValue(color).trim();

			//** Colors obj
			const obj = {
				primary: {
					light: getHex('--primary').concat('1a'),
					main: getHex('--primary')
				},
				secondary: {
					light: getHex('--secondary').concat('1a'),
					main: getHex('--secondary')
				},
				success: {
					light: getHex('--success').concat('1a'),
					main: getHex('--success')
				},
				danger: {
					light: getHex('--danger').concat('1a'),
					main: getHex('--danger')
				},
				warning: {
					light: getHex('--warning').concat('1a'),
					main: getHex('--warning')
				},
				info: {
					light: getHex('--info').concat('1a'),
					main: getHex('--info')
				},
				dark: {
					light: getHex('--dark').concat('1a'),
					main: getHex('--dark')
				},
				white: '#fff',
				black: '#22292f',
				gray: {
					50: '#f6f6f6',
					75: '#F8FBFF',
					100: '#babfc7', // lightest
					200: '#ededed', // lighter
					300: '#dae1e7', // light
					400: '#636363',
					500: '#adb5bd',
					600: '#b8c2cc', // $gray
					650: '#4e5154',
					700: '#445065',
					750: '#363B4D',
					800: '#1e1e1e', // dark
					900: '#2a2e30'
				},
				blue: {
					light: '#F3F8FF',
					main: '#002575'
				},
				green: {
					main: '#00852A'
				}
			};

			setColors({ ...obj });
		}
	}, []);

	return (
		<ThemeColors.Provider value={{ colors }}>{children}</ThemeColors.Provider>
	);
};

export { ThemeColors, ThemeContext };
